module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.getValue), function(value) {
    return [_c('div', {
      staticClass: "grid-container"
    }, [_c('dl', {
      staticClass: "grid-container-attributes"
    }, [_c('dd', [_vm._v(_vm._s(_vm.getValueDependsOnType(value)))])])])]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-53474e4d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/grid/JsonArrayColumnComponent.vue
// module id = 1289
// module chunks = 2